import React, { useEffect, useState } from "react";
import UserTable from "./components/UserTable";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import {
  selectLoadingPendingUsers,
  selectPendingUsers,
} from "feature/admin/slice";
import { fetchPendingUsers, handlePendingUsers } from "feature/admin/actions";
import ConfirmationModal from "Components/Atoms/ConfirmationModal";
import { InviteAction } from "types/types";

const PendingUsers = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector(selectPendingUsers);
  const loadingUsers = useAppSelector(selectLoadingPendingUsers);
  const [selectedUserInvitationId, setSelectedUserInvitationId] = useState<
    string | null
  >(null);
  const [selectedAction, setSelectedAction] = useState<InviteAction | null>(
    null
  );

  const onContinue = () => {
    if (!selectedUserInvitationId) return;
    if (!selectedAction) return;

    dispatch(
      handlePendingUsers({
        invitationId: selectedUserInvitationId,
        action: selectedAction,
      })
    );

    setSelectedUserInvitationId(null);
    setSelectedAction(null);
  };

  const onCancel = () => {
    setSelectedUserInvitationId(null);
  };
  useEffect(() => {
    dispatch(fetchPendingUsers());
  }, []);

  const handleAction = (id: string | null, action: InviteAction) => {
    if (id === null) return;
    setSelectedUserInvitationId(id);
    setSelectedAction(action);
  };
  return (
    <>
      <ConfirmationModal
        isOpen={selectedUserInvitationId !== null}
        content={`Are you sure you want to ${selectedAction} the invitation?`}
        onContinue={onContinue}
        onCancel={onCancel}
        canContinue={!!selectedUserInvitationId}
      />
      <UserTable
        title={"Pending Users"}
        users={users}
        isLoading={loadingUsers}
        isPendingUsers={true}
        handleAction={handleAction}
        showOrganization
      />
    </>
  );
};

export default PendingUsers;
